import { Client } from '../core/src/models/client'

/*
 * Shared features module for client feature management.
 * This module defines the structure and utility functions for handling client features.
 */

export enum FeatureStatus {
	ENABLED = 'enabled',
	DISABLED = 'disabled',
	BETA = 'beta'
}

export enum Features {
	CONTRACT_TAGS = 'contract-tags',
	TRADE_HUB = 'trade-hub',
}

export function clientHasFeature(client: Client, feature: Features): boolean {
	const featureInList = client.fields?.features?.de?.find(f => f.id === feature)
	return Boolean(featureInList && featureInList.status === FeatureStatus.ENABLED)
}